<template>
  <div id="app" @click="close">
    <div class="header">
      <img src="./assets/Banner.jpg" alt="" />
    </div>
    <!-- <hr /> -->
    <div class="flex">
      <div class="container">
        <div style="display: flex">
          <div
            class="single"
            v-for="(item, index) in textList"
            :key="index"
            @click="selectImage(index)"
            :style="{
              background: activeImage == index ? 'black' : '',
              color: activeImage == index ? '#fff' : '',
            }"
          >
            {{ item }}
          </div>
          <input
            ref="fileInput"
            type="file"
            @change="onFileChange"
            accept="image/*"
            style="display: none"
          />
          <button class="margin-left:10px" @click="triggerFileInput">
            Upload Background
          </button>
        </div>
        <p class="text-rule">
          You can move the neon sign's position by mouse dragging
        </p>
        <canvas
          ref="canvas"
          :width="canvasWidth"
          :height="canvasHeight"
          style="border: 1px solid black"
          @mousedown="startDragging"
          @mousemove="dragText"
          @mouseup="stopDragging"
          @mouseleave="stopDragging"
        ></canvas>
      </div>
      <div class="controls">
        <span>Please enter the text you want to customize below.</span>
        <div class="flex-between">
          Line 1
          <div>
            <!-- <div class="custom-select">
              <div
                class="select-selected"
                @click.stop="
                  () => {
                    dropdownOpen = !dropdownOpen;
                  }
                "
              >
                font <span class="arrow">▼</span>
              </div>
              <div class="select-items width2" v-if="dropdownOpen">
                <div
                  v-for="font in fonts"
                  :key="font"
                  class="select-item2"
                  :style="{
                    fontFamily: font,
                    backgroundColor: selectedFont === font ? 'black' : '',
                    color: selectedFont === font ? '#fff' : '',
                  }"
                  @click="selectFont(font)"
                >
                  {{ font }}
                </div>
              </div>
            </div> -->
            <div class="custom-select">
              <div
                class="select-selected"
                @click.stop="
                  () => {
                    colordownOpen = !colordownOpen;
                  }
                "
              >
                color <span class="arrow">▼</span>
              </div>
              <div class="select-items6 width6" v-if="colordownOpen">
                <div style="width: 100%; text-align: left">
                  Choose a color below
                </div>
                
<!-- 第一个颜色选择 -->
<div
  v-for="(item, index) in colors"
  :key="'color-' + index"
  class="select-color"
  :style="getBackgroundStyle(item)"
  @click="selectColor(item, index)"
  @mouseover="mouseoverChange(index)"
>
  <div class="tip" v-if="index == mouseIndex">
    {{ item.name }}
  </div>
</div>
      
              </div>
            </div>
          
          </div>
        </div>
        <input
          class="input"
          type="text"
          v-model="neonText"
          placeholder="Enter your text"
          @input="drawImage"
          @focus="setActiveInput('input1')"
        />
        <div class="flex-between">
          Line 2
          <div>
            <!-- <div class="custom-select">
              <div
                class="select-selected"
                @click.stop="
                  () => {
                    dropdownOpen2 = !dropdownOpen2;
                  }
                "
              >
                font <span class="arrow">▼</span>
              </div>
              <div class="select-items width2" v-if="dropdownOpen2">
                <div
                  v-for="font in fonts"
                  :key="font"
                  class="select-item2"
                  :style="{
                    fontFamily: font,
                    backgroundColor: selectedFont2 === font ? 'black' : '',
                    color: selectedFont2 === font ? '#fff' : '',
                  }"
                  @click="selectFont(font)"
                >
                  {{ font }}
                </div>
              </div>
            </div> -->
            <div class="custom-select">
              <div
                class="select-selected"
                @click.stop="
                  () => {
                    colordownOpen2 = !colordownOpen2;
                  }
                "
              >
                color <span class="arrow">▼</span>
              </div>
              <div class="select-items6 width6" v-if="colordownOpen2">
                <div style="width: 100%; text-align: left">
                  Choose a color below
                </div>
                
<!-- 第二个颜色选择 -->
<div
  v-for="(item, index) in colors"
  :key="'color2-' + index"
  class="select-color"
  :style="getBackgroundStyle(item)"
  @click="selectColor2(item, index)"
  @mouseover="mouseoverChange2(index)"
>
  <div class="tip" v-if="index == mouseIndex2">
    {{ item.name }}
  </div>
</div>
      
              </div>
            </div>
          </div>
        </div>
        <input
          class="input"
          type="text"
          v-model="neonText2"
          placeholder="Enter your text"
          @input="drawImage"
          @focus="setActiveInput('input2')"
        />
        <div class="custom-select1">
          <div
            class="select-selected text"
            @click.stop="
              () => {
                sizeDropdownOpen = !sizeDropdownOpen;
              }
            "
          >
            size: {{ selectedName }} <span class="arrow">▼</span>
          </div>
          <div
            class="select-items8 width8"
            v-if="sizeDropdownOpen"
            style="
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              box-shadow: 0px 4px 6px rgba(200, 200, 200, 0.5);
            "
          >
            <div
              style="
                width: 100px;
                border: 1px solid #000;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.7vw;
                margin: 0;
                margin-bottom: 2px;
                margin-left: 4px;
              "
              v-for="(size, index) in fontSizes"
              :key="index"
              class="select-item"
              :style="{
                backgroundColor: selectedIndex === index ? '#ddd' : '',
              }"
              @click="selectSize(size, index)"
            >
              {{ size.name }}
            </div>
          </div>
        </div>
        <div v-if="neonText || neonText2" class="content">
          <span style="color: red; text-align: left; font-size: 14px"
            >Please copy these customizations to etsy's personalized box!</span
          >
          <div
            style="
              display: flex;
              flex-direction: column;
              border: 2px solid #ddd;
              width: 100%;
              padding: 10px 0;
            "
          >
            <span v-if="neonText"
              >lin1->{{ neonText }} | Font:{{ selectedFont }} | Color:{{
                colorname1
              }}</span
            >
            <span v-if="neonText2"
              >lin2->{{ neonText2 }} | Font:{{ selectedFont2 }} | Color:{{
                colorname2
              }}</span
            >
          </div>
        </div>
        <button class="button" @click="downloadImage">Download</button>
        <div class="item">
          <div class="item_title">
            <span>CHOOSE FONT</span>
            <span
              >Pick from over 50 typefaces. Prices vary by the amount of LED
              neon required.</span
            >
          </div>
          <div class="select-items width2">
            <div
              v-for="font in fonts"
              :key="font"
              class="select-item2"
              :style="{
                fontFamily: font,
                backgroundColor:
                  (activeInput === 'input1' && selectedFont === font) ||
                  (activeInput === 'input2' && selectedFont2 === font)
                    ? 'black'
                    : '',
                color:
                  (activeInput === 'input1' && selectedFont === font) ||
                  (activeInput === 'input2' && selectedFont2 === font)
                    ? '#fff'
                    : '',
              }"
              @click="selectFont(font)"
            >
              {{ font }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer
      style="text-align: center; padding: 20px 0; background-color: #f0f0f0;margin-top:15px;"
    >
      <p>
        备案号:
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="color: #007bff"
          >粤ICP备2024334936号</a
        >
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      canvasWidth: 1200,
      canvasHeight: 800,
      image: null,
      neonText: "",
      neonText2: "",
      neonColor: "#ff00ff",
      neonColor2: "#ff00ff",
      selectedFont: "Action",
      selectedFont2: "Action",
      selectedSize: "",
      selectedName: "",
      fonts: [
        "Action",
        "Alexa",
        "Amanda",
        "Amsterdam",
        "Austin",
        "Avante",
        "Barcelona",
        "Bayview",
        "Beachfront",
        "Brittany",
        "Buttercup",
        "Chelsea",
        "Christmas",
        "ClassicType",
        "Cudi",
        "Freehand",
        "Freespirit",
        "George",
        "Greenworld",
        "Joy",
        "Keith",
        "LOVENEON",
        "LoveNote",
        "Madina",
        "Mayfair",
        "Melbourne",
        "MONACO",
        "NeonGlow",
        "NEONLITE",
        "Neonscript",
        "NeoTokyo",
        "Nevada",
        "NewCursive",
        "Northshore",
        "Photogenic",
        "Rocket",
        "Royalty",
        "SCIFI",
        "Signature",
        "Typewriter",
        "Venetian",
        "Vintage",
        "WAIKIKI",
        "WildScript",
        "Young",
      ],
      textList: ["Wedding", "Bedroom", "Business"],
      colors: [
        { hex: "#ffffff", name: "Cool White" },
        { hex: "#f9f79d", name: "Warm White" },
        { hex: "#fffb3a", name: "Yellow" },
        { hex: "#f991e9", name: "Light Pink" },
        { hex: "#2afffd", name: "Ice Blue" },
        { hex: "#06e7a1", name: "Green" },
        { hex: "#fd40f9", name: "Hot Pink" },
        { hex: "#fd263a", name: "Red" },
        { hex: "#048bff", name: "Dark Blue" },
        { hex: "#9536fd", name: "Purple" },
        { hex: "#ff8114", name: "Orange" },
              {
        gradient: ["#fffb3a", "#f991e9"],
        name: "Yellow to Light Pink Gradient"
      },
      {
        gradient: ["#048bff", "#9536fd"],
        name: "Dark Blue to Purple Gradient"
      }
      ],
      fontSizes: [
        { name: '16" (40cm)', value: "120" },
        { name: '20" (50cm)', value: "140" },
        { name: '24" (60cm)', value: "180" },
        { name: '28" (70cm)', value: "220" },
        { name: '31" (80cm)', value: "260" },
        { name: '35" (90cm)', value: "300" },
        { name: '40" (100cm)', value: "340" },
        { name: '43" (110cm)', value: "380" },
        { name: '47" (120cm)', value: "420" },
        { name: '50" (130cm)', value: "460" },
        { name: '59" (150cm)', value: "500" },
      ],
      ctx: null,
      textX: 400,
      textX2: 500,
      textY: 300,
      textY2: 400,
      isDragging: false,
      isDragging2: false,
      offsetX: 0,
      offsetX2: 0,
      offsetY: 0,
      offsetY2: 0,
      dropdownOpen: false,
      dropdownOpen2: false,
      colordownOpen: false,
      sizeDropdownOpen: false,
      colordownOpen2: false,
      activeIndex: 0,
      activeImage: -1,
      mouseIndex: -1,
      colorname1: "",
      colorname2: "",
      selectedIndex: "",
      activeInput: "input1",
    };
  },
  mounted() {
    this.ctx = this.$refs.canvas.getContext("2d");
    this.selectSize(this.fontSizes[0], 0);
    this.selectColor(this.colors[0], 0);
    this.selectColor2(this.colors[0], 0);
    this.selectImage(0);
  },
  methods: {
      getBackgroundStyle(item) {
        if (item.gradient && Array.isArray(item.gradient) && item.gradient.length > 1) {
          return {
            background: `linear-gradient(to right, ${item.gradient.join(', ')})`,
          };
        }
        return {
          background: item.hex,
        };
      },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        if (!this.textList.includes("custom")) {
          this.textList.push("custom");
        }
        this.activeImage = 3;
        this.newImage = e.target.result;
        this.image = new Image();
        this.image.src = e.target.result;
        this.image.onload = () => {
          this.drawImage();
        };
      };
      reader.readAsDataURL(file);
    },
    selectImage(index) {
      this.activeImage = index;
      this.image = new Image();
      if (index == 3) {
        this.image.src = this.newImage;
      } else {
        this.image.src = require(`./assets/image/${index + 1}.jpg`);
      }
      this.image.onload = () => {
        this.drawImage();
      };
    },
    drawImage() {
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      if (this.image) {
        this.ctx.drawImage(
          this.image,
          0,
          0,
          this.canvasWidth,
          this.canvasHeight
        );
      }
      this.drawNeonText();
      this.drawNeonText2();
    },
    mouseoverChange(index) {
      this.mouseIndex = index;
    },
      mouseoverChange2(index) {
    this.mouseIndex2 = index;
  },
    drawNeonText() {
      const fontSize = this.adjustFontSize(
        this.neonText,
        this.neonText2,
        this.selectedSize,
        this.selectedFont
      );
      this.ctx.font = `400 ${fontSize}px "${this.selectedFont}"`;
      this.ctx.textAlign = "center";
      this.ctx.textBaseline = "middle";
      this.ctx.fillStyle = this.neonColor;
      this.ctx.shadowColor = this.neonColor;
      this.ctx.shadowBlur = 20;
      this.ctx.fillText(this.neonText, this.textX, this.textY);
    },
    drawNeonText2() {
      const fontSize2 = this.adjustFontSize(
        this.neonText,
        this.neonText2,
        this.selectedSize,
        this.selectedFont2
      );
      this.ctx.font = `400 ${fontSize2}px "${this.selectedFont2}"`;
      this.ctx.textAlign = "center";
      this.ctx.textBaseline = "middle";
      this.ctx.fillStyle = this.neonColor2;
      this.ctx.shadowColor = this.neonColor2;
      this.ctx.shadowBlur = 20;
      this.ctx.fillText(this.neonText2, this.textX2, this.textY2);
    },
    setActiveInput(input) {
      this.activeInput = input;
    },
    selectFont(font) {
      if (this.activeInput === "input1") {
        this.selectedFont = font;
      } else if (this.activeInput === "input2") {
        this.selectedFont2 = font;
      }
      this.drawImage();
    },
    // selectColor(item, index) {
    //   this.neonColor = item.hex;
    //   this.activeIndex = index;
    //   this.colorname1 = item.name;
    //   this.drawImage();
    //   this.colordownOpen = false;
    // },
  // 选择颜色（第一个）
  selectColor(item, index) {
    this.activeIndex = index;
    this.colorname1 = item.name;

    if (item.gradient) {
      this.neonColor1 = `linear-gradient(to right, ${item.gradient.join(', ')})`;
    } else {
      this.neonColor1 = item.hex;
    }

    this.drawImage();
    this.colordownOpen = false;
  },
    // selectColor2(item, index) {
    //   this.neonColor2 = item.hex;
    //   this.activeIndex2 = index;
    //   this.colorname2 = item.name;
    //   this.drawImage();
    //   this.colordownOpen2 = false;
    // },
  selectColor2(item, index) {
    this.activeIndex2 = index;
    this.colorname2 = item.name;

    if (item.gradient) {
      this.neonColor2 = `linear-gradient(to right, ${item.gradient.join(', ')})`;
    } else {
      this.neonColor2 = item.hex;
    }

    this.drawImage();
    this.colordownOpen = false;
  },
    selectSize(size, index) {
      this.selectedIndex = index;
      this.selectedSize = size.value;
      this.selectedName = size.name;
      this.sizeDropdownOpen = false;
      this.drawImage();
    },
    startDragging(event) {
      const mouseX = event.offsetX;
      const mouseY = event.offsetY;

      if (
        mouseX > this.textX - 50 &&
        mouseX < this.textX + 50 &&
        mouseY > this.textY - 25 &&
        mouseY < this.textY + 25
      ) {
        this.isDragging = true;
        this.offsetX = mouseX - this.textX;
        this.offsetY = mouseY - this.textY;
      } else if (
        this.neonText2 &&
        mouseX > this.textX2 - 50 &&
        mouseX < this.textX2 + 50 &&
        mouseY > this.textY2 - 25 &&
        mouseY < this.textY2 + 25
      ) {
        this.isDragging2 = true;
        this.offsetX2 = mouseX - this.textX2;
        this.offsetY2 = mouseY - this.textY2;
      }
    },
    dragText(event) {
      if (this.isDragging) {
        this.textX = event.offsetX - this.offsetX;
        this.textY = event.offsetY - this.offsetY;
      } else if (this.isDragging2) {
        this.textY2 = event.offsetY - this.offsetY2;
        this.textX2 = event.offsetX - this.offsetX2;
      }
      this.drawImage();
    },
    stopDragging() {
      this.isDragging = false;
      this.isDragging2 = false;
    },
    downloadImage() {
      const link = document.createElement("a");
      link.href = this.$refs.canvas.toDataURL("image/png");
      link.download = "neon_design.png";
      link.click();
    },
    close() {
      this.dropdownOpen = false;
      this.dropdownOpen2 = false;
      this.colordownOpen = false;
      this.sizeDropdownOpen = false;
      this.colordownOpen2 = false;
    },
    adjustFontSize(text, text2, maxWidth, font) {
      let fontSize = 1000;
      this.ctx.font = `400 ${fontSize}px "${font}"`;
      while (
        this.ctx.measureText(text).width + this.ctx.measureText(text2).width >
          maxWidth &&
        fontSize > 0
      ) {
        fontSize -= 3;
        this.ctx.font = `400 ${fontSize}px "${font}"`;
      }
      return fontSize;
    },
  },
};
</script>

<style>
@import "./assets/styles.css";
html,
body {
  margin: 0;
  padding: 0;
}
.item {
  margin-top: 15px;
}
.item_title {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.item_title span:first-child {
  font-weight: bold;
}
.item_title span:last-child {
  font-size: 12px;
}

#app {
  text-align: center;
}
.header {
  /* padding: 50px 0; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.header img {
  width: 100%;
  object-fit: cover;
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.tip {
  padding: 5px;
  background: black;
  color: #fff;
  border-radius: 10%;
  position: absolute;
  z-index: 2;
  top: -30px;
  font-size: 12px;
  white-space: nowrap;
  min-width: 40px;
  left: 0;
}
.single {
  padding: 5px;
  border: 2px solid black;
  margin-right: 5px;
}
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}
canvas {
  margin-top: 20px;
  background: #ccc;
}
.controls {
  display: flex;
  flex-direction: column;
  width: 400px;
  /* height: 800px; */
  margin-left: 20px;
  box-shadow: 0px 4px 6px rgba(200, 200, 200, 0.5);
  padding: 20px;
}
.custom-select {
  position: relative;
  display: inline-block;
}
.custom-select1 {
  width: 100%;
  margin-top: 10px;
}

.select-selected {
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  cursor: pointer;
}

.select-items6 {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  z-index: 99;
  right: 0;
}

.width6 {
  width: 257px;
}
.select-items8 {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  z-index: 99;
  right: 10px;
  padding-top: 2px;
}

.width8 {
  width: 420px;
}

.select-items {
  display: flex;
  flex-wrap: wrap;
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  margin-top: 12px;
}

.width {
  width: 257px;
}

.select-item2 {
  cursor: pointer;
  height: 50px;
  width: 97px;
  line-height: 50px;
  border: 2px solid black;
  margin: 1px;
  box-sizing: border-box;
}
.select-item {
  cursor: pointer;
  height: 50px;
  line-height: 50px;
  padding: 5px;
  margin: 5px;
  box-sizing: border-box;
}

.select-color {
  width: 50px;
  height: 50px;
  margin: 5px;
  border: 2px solid #fff;
  position: relative;
}

.select-color:hover {
  border: 2px solid black;
}

.select-item2:hover {
  background-color: #ddd;
}

.arrow {
  float: right;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.input {
  width: 100%;
  height: 30px;
  padding-left: 1em;
  box-sizing: border-box;
  margin-top: 10px;
}
.text {
  height: 30px;
  line-height: 30px;
}
.text-rule {
  position: absolute;
  left: 10px;
  bottom: 10px;
  width: 8rem;
  display: inline-block;
  text-align: left;
  color: #fff;
}
.button {
  height: 40px;
  padding: 10px 0;
  background: black;
  color: #fff;
  margin-top: 10px;
}
</style>
